import { routes } from "../../assets/constants";
import { ApiMethod } from "../models/api-types.type";
import { useAuthContext } from "./use-auth-context.hook";
import { useVendorsApi } from "./use-vendors-api.hook";
import Config from "../../modules/vendor/settings/models/config.model";

export let areas: any[] = []
export let config: Config

export const resetConfig = () => {
  config = null
  areas = []
}

export const useSettingsApi = () => {
  const { sendAuthGuardedRequest } = useAuthContext();
  const vendorsAPI = useVendorsApi()
  const fonts = ["Lexend", "Roboto", "Open Sans", "Montserrat", "Lato", "Poppins", "Source Sans Pro", "Raleway", "Noto Sans", "Inter", "Roboto Slab", "Merriweather", "Playfair Display"]

  const findConfig = async (): Promise<any> => {
    const response: any = await sendAuthGuardedRequest(
      ApiMethod.GET,
      routes.settings.findConfig,
    )
    const companyConfig: Config = response
    config = companyConfig
    areas = await vendorsAPI.findVendorAreas()
    return companyConfig
  };
  
  const updateConfig = async (config): Promise<any> => {
    return await sendAuthGuardedRequest(
      ApiMethod.PATCH,
      routes.settings.patch,
      config
    )
  };

  const uploadLogo = async (file: File): Promise<{ logoUrl: string }> => {
    const formData = new FormData();
    formData.append('logo', file);

    const response: any = await sendAuthGuardedRequest(
      ApiMethod.POST,
      routes.settings.uploadLogo,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response as { logoUrl: string };
  };

  return {
    findConfig,
    updateConfig,
    uploadLogo,
    fonts
  };

};
